import { Button } from '@askable/ui/core/button';
import { showMessages } from '@intercom/messenger-js-sdk';
import { Trans, useTranslation } from 'react-i18next';

import { ErrorState } from 'components/ErrorState/ErrorState';
import { isChunkLoadError } from 'src/lib/reload-on-chunk-error';

import type { ErrorComponentProps } from '@tanstack/react-router';

/**
 * Fallback for a route that threw while rendering. Replaces only the failing
 * route's slot, so the app chrome stays usable. A lazy component keeps a failed
 * import, so only a page reload retries a chunk error.
 */
export const RouteError = ({ error, reset }: ErrorComponentProps) => {
  const { t } = useTranslation();
  const retry = isChunkLoadError(error) ? () => window.location.reload() : reset;

  return (
    <ErrorState
      variant="error"
      title={t('sections.errorBoundary.default')}
      description={
        <Trans
          i18nKey="sections.errorState.unknown.description"
          components={{ 1: <Button variant="link" className="inline p-0" onClick={showMessages} /> }}
        />
      }
      action={{ label: t('global.tryAgain'), onClick: retry }}
    />
  );
};
